import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../../../api";

export default function PlantMachinery() {
  const { projectId } = useParams();
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [contingencyPercent, setContingencyPercent] = useState(0);
  const [taxPercent, setTaxPercent] = useState(0);
  const [totals, setTotals] = useState({
    subtotal: 0,
    contingency: 0,
    tax: 0,
    grand: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!projectId) {
      setLoading(false);
      return;
    }
    API.get(`/user/project-inputs/${projectId}`)
      .then(({ data }) => {
        setRows(
          Array.isArray(data.plantMachineryData) ? data.plantMachineryData : []
        );
        setContingencyPercent(data.plantContingencies || 0);
        setTaxPercent(data.plantGstPercent || 0);
      })
      .catch((err) => {
        if (err.response?.status === 404) {
          setRows([]);
        } else {
          console.error(err);
          setError("Unable to load data");
        }
      })
      .finally(() => setLoading(false));
  }, [projectId]);

  useEffect(() => {
    const sub = rows.reduce((sum, r) => sum + (Number(r.amount) || 0), 0);
    const cont = (sub * contingencyPercent) / 100;
    const tax = ((sub + cont) * taxPercent) / 100;
    const grand = sub + cont + tax;
    setTotals({ subtotal: sub, contingency: cont, tax: tax, grand: grand });
  }, [rows, contingencyPercent, taxPercent]);

  const formatINR = (num) =>
    Number(num).toLocaleString("en-IN", { maximumFractionDigits: 2 });

  if (loading)
    return (
      <div className="flex h-64 items-center justify-center">
        <svg
          className="animate-spin h-10 w-10 text-gray-500"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"
          />
        </svg>
      </div>
    );
  if (error)
    return <div className="text-red-600 text-center py-8">{error}</div>;

  return (
    <div className="bg-white">
      <div className="overflow-x-auto mb-8 shadow-lg rounded-lg">
        <table className="min-w-full table-auto border-collapse">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-2 py-1 border border-gray-200 text-left font-medium">
                Sl No
              </th>
              <th className="px-2 py-1 border border-gray-200 text-left font-medium">
                Particular
              </th>
              <th className="px-2 py-1 border border-gray-200 text-left font-medium">
                Supplier
              </th>
              <th className="px-2 py-1 border border-gray-200 text-left font-medium">
                Quantity
              </th>
              <th className="px-2 py-1 border border-gray-200 text-right font-medium">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, idx) => (
              <tr key={idx} className="even:bg-gray-50">
                <td className="px-2 py-1 border border-gray-200">{r.slNo}</td>
                <td className="px-2 py-1 border border-gray-200">
                  {r.particular}
                </td>
                <td className="px-2 py-1 border border-gray-200">
                  {r.supplier}
                </td>
                <td className="px-2 py-1 border border-gray-200">
                  {r.quantity}
                </td>
                <td className="px-2 py-1 border border-gray-200 text-right">
                  ₹{formatINR(r.amount)}
                </td>
              </tr>
            ))}
            <tr className="bg-gray-100 font-semibold">
              <td colSpan={4} className="px-2 py-1 border border-gray-200">
                Subtotal
              </td>
              <td className="px-2 py-1 border border-gray-200 text-right">
                ₹{formatINR(totals.subtotal)}
              </td>
            </tr>
            <tr className="bg-gray-100 font-semibold">
              <td colSpan={4} className="px-2 py-1 border border-gray-200">
                Contingency ({contingencyPercent}%)
              </td>
              <td className="px-2 py-1 border border-gray-200 text-right">
                ₹{formatINR(totals.contingency)}
              </td>
            </tr>
            <tr className="bg-gray-100 font-semibold">
              <td colSpan={4} className="px-2 py-1 border border-gray-200">
                GST ({taxPercent}%)
              </td>
              <td className="px-2 py-1 border border-gray-200 text-right">
                ₹{formatINR(totals.tax)}
              </td>
            </tr>
            <tr className="bg-gray-200 font-bold">
              <td colSpan={4} className="px-2 py-1 border border-gray-200">
                Grand Total
              </td>
              <td className="px-2 py-1 border border-gray-200 text-right">
                ₹{formatINR(totals.grand)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
